// extracted by mini-css-extract-plugin
export default {"container":"stripePayment_container__Std-6","checkout":"stripePayment_checkout__gtB+x","App-Payment":"stripePayment_App-Payment__ZUxGi","cross-btn":"stripePayment_cross-btn__vY9eQ"};